var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAutomated = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 13331"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.074 22.155c0 3.572-2.041 5.1-5.1 5.1H13.76c-3.062 0-5.1-1.531-5.1-5.1v-6.128c0-3.569 2.041-5.1 5.1-5.1h3.062a4.4 4.4 0 0 0-.227 1.418v4.423a3.7 3.7 0 0 0 1.009 2.676 3.7 3.7 0 0 0 2.676 1.009v1.574a.743.743 0 0 0 1.145.612l3.278-2.189h2.957a4.4 4.4 0 0 0 1.418-.227Z",
  "data-name": "Path 4947"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.342 16.768a3.46 3.46 0 0 1-2.268 3.459 4.4 4.4 0 0 1-1.418.227h-2.948l-3.278 2.189a.743.743 0 0 1-1.145-.612v-1.577a3.7 3.7 0 0 1-2.676-1.009 3.7 3.7 0 0 1-1.01-2.677v-4.423a4.4 4.4 0 0 1 .227-1.418 3.46 3.46 0 0 1 3.459-2.268h7.372a3.482 3.482 0 0 1 3.686 3.686Z",
  "data-name": "Path 4948"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.784 31.341h8.165",
  "data-name": "Path 4949"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.867 27.258v4.083",
  "data-name": "Path 4950"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.196 14.613h.01",
  "data-name": "Path 4953"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.021 14.613h.01",
  "data-name": "Path 4954"
}))));
export { SvgAutomated as ReactComponent };
export default __webpack_public_path__ + "static/media/automated.ed333b1b5a76e36ab2c8a70dfdf07f18.svg";